module.exports = __webpack_public_path__ + "img/bg_theme00013.4234d462.jpg";